@if (label()) {
  <label class="esn-text-field__label" [for]="id">{{ label() }}</label>
}
<div
  class="esn-text-field__box"
  [class.esn-text-field__box--error]="invalid()"
  [class.esn-text-field__box--disabled]="isDisabled()"
>
  @if (kind() === 'notes') {
    <textarea
      class="esn-text-field__control esn-text-field__control--notes"
      rows="1"
      [id]="id"
      [value]="value()"
      [placeholder]="placeholder()"
      [disabled]="isDisabled()"
      [readOnly]="readonly()"
      [required]="required()"
      [attr.name]="name()"
      [attr.maxlength]="maxlength()"
      [attr.aria-invalid]="invalid()"
      [attr.aria-describedby]="message() ? messageId : null"
      (input)="handleInput($event)"
      (blur)="handleBlur()"
    ></textarea>
  } @else {
    <input
      class="esn-text-field__control"
      [id]="id"
      [type]="nativeType()"
      [value]="value()"
      [placeholder]="placeholder()"
      [disabled]="isDisabled()"
      [readOnly]="readonly()"
      [required]="required()"
      [attr.name]="name()"
      [attr.autocomplete]="autocomplete()"
      [attr.maxlength]="maxlength()"
      [attr.aria-invalid]="invalid()"
      [attr.aria-describedby]="message() ? messageId : null"
      (input)="handleInput($event)"
      (blur)="handleBlur()"
    />
    @if (type() === 'password') {
      <button
        type="button"
        class="esn-text-field__reveal"
        [disabled]="isDisabled()"
        [attr.aria-label]="revealLabel()"
        [attr.aria-pressed]="revealed()"
        (click)="toggleReveal()"
      >
        <esn-icon [name]="revealed() ? 'eye-off' : 'eye'" [size]="24" />
      </button>
    }
  }
</div>
@if (message()) {
  <p class="esn-text-field__message" [class.esn-text-field__message--error]="invalid()" [id]="messageId">
    {{ message() }}
  </p>
}
